import React from "react";
import {
  Box,
  Button,
  Grid,
  MenuItem,
  TextField,
  Toolbar,
  Tooltip,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { Controller } from "react-hook-form";
import { Add } from "@mui/icons-material";

const InputFieldOrder = ({
  fieldName,
  errors,
  remove,
  fieldsArray,
  control,
  appendfunc,
}) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
      {fieldsArray?.map((item, index) => (
        <div
          key={item.id}
          className=""
          style={{ display: "flex", flexDirection: "column", gap: "20px" }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              margin: "10px 0px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                gap: "20px",
              }}
            >
              <Controller
                name={`${fieldName}[${index}].link`}
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Link"
                    className="w-50"
                    error={Boolean(
                      errors[fieldName] && errors[fieldName][index]?.link
                    )}
                    helperText={
                      errors[fieldName] &&
                      errors[fieldName][index]?.link?.message
                    }
                  />
                )}
              />

              <Controller
                name={`${fieldName}[${index}].text`}
                control={control}
                render={({ field }) => (
                  <TextField
                    label="Text"
                    {...field}
                    error={errors[fieldName] && errors[fieldName][index]?.text}
                    helperText={
                      (errors[fieldName] &&
                        errors[fieldName][index]?.text?.message) ||
                      ""
                    }
                    className="w-50"
                  />
                )}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                gap: "20px",
              }}
            >
              <Controller
                name={`${fieldName}[${index}].target`}
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Target"
                    select
                    className="w-50"
                    error={
                      errors[fieldName] && errors[fieldName][index]?.target
                    }
                    helperText={
                      (errors[fieldName] &&
                        errors[fieldName][index]?.target?.message) ||
                      ""
                    }
                  >
                    <MenuItem value="_self">_self</MenuItem>
                    <MenuItem value="_blank">_blank</MenuItem>
                  </TextField>
                )}
              />
              <Controller
                name={`${fieldName}[${index}].order`}
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    select
                    label="Order"
                    value={field.value || ""}
                    className="w-50"
                    error={errors[fieldName] && errors[fieldName][index]?.order}
                    helperText={
                      (errors[fieldName] &&
                        errors[fieldName][index]?.order?.message) ||
                      ""
                    }
                  >
                    {[...Array(15).keys()].map((number) => (
                      <MenuItem
                        key={number + 1}
                        value={(number + 1).toString()}
                      >
                        {number + 1}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </Box>
          </div>
          <div className="d-flex justify-content-end">
            {fieldsArray?.length > 0 && (
              <Tooltip title="Delete" arrow>
                <DeleteIcon
                  onClick={() => {
                    remove(index);
                  }}
                  style={{ color: "red", cursor: "pointer" }}
                />
              </Tooltip>
            )}
          </div>
        </div>
      ))}
      <Grid className="d-flex justify-content-between">
        <Tooltip title="Add" arrow>
          <Button
            className="button "
            variant="outlined"
            disableElevation
            startIcon={<Add />}
            onClick={() =>
              appendfunc({
                file: null,
                link: "",
                target: "",
                order: null,
                alt: "",
              })
            }
          >
            Add
          </Button>
        </Tooltip>
      </Grid>
    </div>
  );
};

export default InputFieldOrder;
